import React from 'react'
import { UseFormWatch } from 'react-hook-form'

import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalContent
} from '@clientbase/clientbase-library'
import { Stack, Typography } from '@mui/material'
import CreatePaymentLinkPreview from 'templates/PaymentLink/components/Preview'
import CreatePaymentLinkFormInterface, {
  ExtraField,
  PaymentLink
} from 'templates/PaymentLink/interface'

import { ExtraFieldItem } from 'components/ExtraFieldsManager'
import IconContainer from 'components/IconContainer/IconContainer'

interface ModalPaymentLinkPreviewProps {
  isOpen: boolean
  handleClose: () => void
  watch: UseFormWatch<CreatePaymentLinkFormInterface>
  extraFields: ExtraField[] | ExtraFieldItem[]
  paymentLink?: PaymentLink
  title?: string
}

const ModalPaymentLinkPreview = ({
  isOpen,
  handleClose,
  watch,
  extraFields,
  paymentLink,
  title
}: ModalPaymentLinkPreviewProps) => {
  const formData = watch()
  const previewTitle = title || formData.title || 'Visualizar modelo'

  return (
    <>
      <Modal
        handleClose={handleClose}
        open={isOpen}
        width="100%"
        maxWidth="85vw"
        maxHeight="90vh"
        height="100vh"
        zIndex={1400}
        disablePortal={false}
      >
        <ModalBody>
          <ModalHeader onClose={handleClose}>
            <Stack direction="row" alignItems="center" gap={2}>
              <IconContainer icon="visibility" />
              <Typography variant="smBold">{previewTitle}</Typography>
            </Stack>
          </ModalHeader>
          <ModalContent sx={{ padding: 0 }}>
            <CreatePaymentLinkPreview
              watch={watch}
              extraFields={extraFields}
              isMobile={false}
              paymentLink={paymentLink}
            />
          </ModalContent>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalPaymentLinkPreview
